module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('headerTop'), _vm._v(" "), _c('div', {
    staticClass: "swiperImg",
    class: _vm.detail.show_type == 2 || _vm.detail.show_type == 1 ? 'little' : '',
    style: ({
      backgroundImage: 'url(' + _vm.$index.addurl(_vm.detail.background_img) + ')'
    })
  }, [(_vm.detail.show_type == 2 || _vm.detail.show_type == 1) ? _c('div', {
    staticClass: "videoDivs",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toZb(_vm.detail.url)
      }
    }
  }, [(_vm.imgStatus) ? _c('img', {
    staticClass: "bofang",
    attrs: {
      "src": require("../../assets/image/bofang.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.play.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.detail.show_type == 2) ? _c('div', {
    staticClass: "videoDiv"
  }, [_c('video', {
    ref: "videoPlay",
    staticClass: "videoC",
    attrs: {
      "id": "videoPlay",
      "type": "video/mp4",
      "controls": "true",
      "src": _vm.$index.addurl(_vm.detail.video_file)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.detail.show_type == 1) ? _c('div', {
    staticClass: "videoDiv"
  }, [_c('img', {
    attrs: {
      "src": _vm.$index.addurl(_vm.detail.url_image),
      "alt": ""
    }
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center page-content",
    style: ({
      animation: _vm.animation
    })
  }, [_c('div', {
    staticClass: "child",
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3338a626"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/study/studydetail.vue
// module id = 1086
// module chunks = 1